import { useState, useEffect, useRef } from "react"
import styles from "./gifpicker.module.css"

const API_KEY = process.env.REACT_APP_GIPHY_KEY || ""

export default function GifPicker({ onSelect, onClose }) {
    const [query, setQuery] = useState("")
    const [gifs, setGifs] = useState([])
    const [loading, setLoading] = useState(false)
    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current?.focus()
        fetchGifs("trending")
    }, [])

    async function fetchGifs(tipo, q = "") {
        if (!API_KEY) return
        setLoading(true)
        try {
            const url = tipo === "trending"
                ? `https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=24&rating=g`
                : `https://api.giphy.com/v1/gifs/search?api_key=${API_KEY}&q=${encodeURIComponent(q)}&limit=24&rating=g`
            const res = await fetch(url)
            const json = await res.json()
            setGifs(json.data || [])
        } catch {
            setGifs([])
        } finally {
            setLoading(false)
        }
    }

    function handleSearch(e) {
        e.preventDefault()
        if (query.trim()) fetchGifs("search", query)
    }

    function handleOverlayClick(e) {
        if (e.target === e.currentTarget) onClose()
    }

    return (
        <div className={styles.overlay} onMouseDown={handleOverlayClick}>
            <div className={styles.modal}>

                <div className={styles.header}>
                    <span className={styles.titulo}>Inserir GIF</span>
                    <button className={styles.btnFechar} onClick={onClose}>✕</button>
                </div>

                <form className={styles.searchBar} onSubmit={handleSearch}>
                    <input
                        ref={inputRef}
                        className={styles.input}
                        value={query}
                        onChange={e => setQuery(e.target.value)}
                        placeholder="Buscar GIFs..."
                    />
                    <button type="submit" className={styles.btnBuscar}>Buscar</button>
                </form>

                {!API_KEY && (
                    <div className={styles.semChave}>
                        <p>Adicione sua chave Giphy no arquivo <code>.env</code>:</p>
                        <code>REACT_APP_GIPHY_KEY=sua_chave_aqui</code>
                        <p>Chave gratuita em <strong>developers.giphy.com</strong></p>
                    </div>
                )}

                {loading && (
                    <div className={styles.loading}>
                        <span className={styles.spinner} />
                        Carregando...
                    </div>
                )}

                {!loading && gifs.length === 0 && API_KEY && (
                    <p className={styles.vazio}>Nenhum GIF encontrado.</p>
                )}

                <div className={styles.grid}>
                    {gifs.map(gif => (
                        <button
                            key={gif.id}
                            className={styles.gifBtn}
                            onClick={() => {
                                onSelect(gif.images.original.url)
                                onClose()
                            }}
                            title={gif.title}
                        >
                            <img
                                src={gif.images.fixed_width_small.url}
                                alt={gif.title}
                                loading="lazy"
                            />
                        </button>
                    ))}
                </div>

                <div className={styles.footer}>
                    Powered by GIPHY
                </div>

            </div>
        </div>
    )
}
